//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hasWindow from '~/mixins/hasWindow'

export default {
  mixins: [hasWindow],

  middleware: [
    'auth',

    /**
     * Redirect to pretest if has not taken pretest yet.
     */
    // async ({ $auth, store, redirect }) => {
    //   // Pretest only for girls.
    //   if ($auth.isGirl) {
    //     await store.dispatch('quizzes/maybeFetch', { code: Quiz.CODE_PRETEST })
    //     const quiz = store.getters['quizzes/find'](['code', Quiz.CODE_PRETEST])
    //
    //     if (quiz && quiz.user_point === null) redirect('/kelas-online/pretest')
    //   }
    // },
  ],

  head() {
    return { title: 'Kelas Online' }
  },
}
